import { IPaginationElement } from './pagination';

export enum FileType {
    CARGA_MASIVA = 0,
    DOCUMENTACION = 1
}

export class HistoricoAccesoFichero implements IPaginationElement {
    id: number;
    accion: string;
    fecha: string;
    username: string;
    producto: string;
    fechaUTC: Date;

    constructor() { }

    static toModel(json: string): HistoricoAccesoFichero {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new HistoricoAccesoFichero();
        toReturn.accion = data.accion;
        toReturn.fecha = data.fecha;
        toReturn.username = data.username;
        toReturn.producto = data.producto;

        return toReturn;
    }
}

export class FileResponseData {
    contenido: number;
    fecha: string;
    GUID: string;
    idContenido: number;
    idObservacion: number;
    idSolicitud: number;
    id: number;
    nombreFichero: string;
    status: string;

    constructor() { }

    static toModel(json: string): FileResponseData {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new FileResponseData();
        toReturn.id = data.Id;
        toReturn.contenido = data.Contenido;
        toReturn.fecha = data.FECHA;
        toReturn.GUID = data.GUID;

        toReturn.idContenido = data.ID_CONTENIDO;
        toReturn.idObservacion = data.ID_OBSERVACIONES;
        toReturn.idSolicitud = data.ID_SOLICITUD;

        toReturn.nombreFichero = data.NOMBRE_FICHERO;
        toReturn.status = data.STATUS;

        return toReturn;
    }
 }
